<template>
  <div class="creative">
    <div class="creative_layout">
      <div class="left">
        <p class="wow fadeInUp enProductTitle">
          Creative and Technical Support
        </p>
        <p class="wow fadeInUp enProductCont">
          Our ecosystem partners with exceptional capabilities, from creative
          conception to complex full-scale execution, fully facilitate the
          efficient transformation of virtual production from inspiration to
          final creation.
        </p>
        <router-link
          v-if="isColor"
          :to="{ name: 'enCaseDemonstration', hash: '#specific-position' }"
          class="creative_call1"
          >Contact us</router-link
        >
        <router-link
          v-else
          :to="{ name: 'enCaseDemonstration', hash: '#specific-position' }"
          class="creative_call2"
          >Contact us</router-link
        >
      </div>
      <div class="rig">
        <img :src="imgUrl" alt="" class="wow fadeInUp" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imgUrl: {
      type: String,
      default:
        "https://download.hecoos.com/enlightv/2025-17/9ff538df30d9ff4a3bf4a58d9bb069bf.png",
    },
    isColor: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
/* 创意模块 */
.creative {
  width: 100%;
  padding: 110px 90px;
  background-color: #000;
  color: #fff;
  box-sizing: border-box;
  /* 确保 padding 不会使元素超出宽度 */

  .creative_layout {
    display: flex;
    justify-content: space-between;
    max-width: 1400px;
    // padding: 0 15px;
    box-sizing: border-box;
    margin: 0 auto;
    .left {
      flex: 1;
      padding-right: 38px;
      box-sizing: border-box;
      .enProductTitle {
        font-size: 48px;
        font-weight: 900;
        margin-bottom: 20px;
      }
      .enProductCont {
        font-size: 24px;
        line-height: 37px;
        font-weight: 400;
      }
    }
    .rig {
      width: 40%;
    }
    .rig img {
      width: 100%;
      max-width: 647px;
      object-fit: cover;
    }

    .creative_call1 {
      display: inline-block;
      text-decoration: none;
      color: #fff;
      background-color: #7948ea;
      // width: 151px;
      // height: 50px;
      border-radius: 40px;
      text-align: center;
      line-height: 32px;
      font-size: 22px;
      padding: 16px 24px;
      margin-top: 70px;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        // transform: scale(1.05);
        background-color: #fff;
        color: #7948ea;
      }
    }

    .creative_call2 {
      display: inline-block;
      text-decoration: none;
      background-color: #147cf5;
      color: #fff;
      // width: 151px;
      // height: 50px;
      line-height: 32px;
      border-radius: 40px;
      padding: 16px 24px;
      text-align: center;
      font-size: 22px;
      margin-top: 70px;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        // transform: scale(1.05);
        background-color: #fff;
        color: #147cf5;
      }
    }
  }
}
@media screen and (max-width: 1350px) {
  .creative {
    .creative_layout {
      .left {
        .p1 {
          font-size: 40px;
          margin-bottom: 30px;
        }
        .p2 {
          font-size: 20px;
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .creative {
    .creative_layout {
      .left {
        .p1 {
          font-size: 35px;
          margin-bottom: 30px;
        }
        .p2 {
          font-size: 18px;
        }
      }
    }
  }
}
@media screen and (max-width: 1100px) {
  .creative {
    .creative_layout {
      .left {
        .p1 {
          font-size: 30px;
          margin-bottom: 30px;
        }
        .p2 {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
